var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceMgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1211 33.5631C22.7071 33.5631 22.3711 33.2271 22.3711 32.8131V25.9531C22.3711 25.5391 22.7071 25.2031 23.1211 25.2031C23.5351 25.2031 23.8711 25.5391 23.8711 25.9531V32.8131C23.8711 33.2271 23.5351 33.5631 23.1211 33.5631",
    fill: "#5034C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7891 33.561C27.3751 33.561 27.0391 33.225 27.0391 32.811V22.668C27.0391 22.254 27.3751 21.918 27.7891 21.918C28.2031 21.918 28.5391 22.254 28.5391 22.668V32.811C28.5391 33.225 28.2031 33.561 27.7891 33.561",
    fill: "#5034C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3789 33.5621C31.9649 33.5621 31.6289 33.2261 31.6289 32.8121V29.5781C31.6289 29.1641 31.9649 28.8281 32.3789 28.8281C32.7929 28.8281 33.1289 29.1641 33.1289 29.5781V32.8121C33.1289 33.2261 32.7929 33.5621 32.3789 33.5621",
    fill: "#5034C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.064 18.5C20.292 18.5 18.5 20.397 18.5 23.335V32.165C18.5 35.103 20.292 37 23.064 37H32.436C35.209 37 37 35.103 37 32.165V23.335C37 20.397 35.209 18.5 32.436 18.5H23.064ZM32.436 38.5H23.064C19.437 38.5 17 35.954 17 32.165V23.335C17 19.546 19.437 17 23.064 17H32.436C36.063 17 38.5 19.546 38.5 23.335V32.165C38.5 35.954 36.063 38.5 32.436 38.5V38.5Z",
    fill: "#5034C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9F5FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceMgt);
export default __webpack_public_path__ + "static/media/finance-mgt.da0e1af7cdaae7a716d038048a83d6be.svg";
export { ForwardRef as ReactComponent };